/* eslint-disable import/prefer-default-export */
export const isBrowser = typeof window !== "undefined"
